var map = {
	"./bug.svg": 421,
	"./dark.svg": 993,
	"./dragon.svg": 107,
	"./electric.svg": 854,
	"./fairy.svg": 682,
	"./fighting.svg": 310,
	"./fire.svg": 750,
	"./flying.svg": 539,
	"./ghost.svg": 344,
	"./grass.svg": 186,
	"./ground.svg": 199,
	"./ice.svg": 133,
	"./normal.svg": 788,
	"./poison.svg": 851,
	"./psychic.svg": 677,
	"./rock.svg": 324,
	"./steel.svg": 55,
	"./water.svg": 707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 498;